import {ActivityVO, ActivityListVO} from './activity.interfaces';
import {All} from './activity.actions';
import {CrudAll, crudInitialState, CrudReducer, CrudState, createCrudDefinition} from '@abydos-angular/store';

export interface ActivityState extends CrudState<ActivityVO> {
}

export const initialState: ActivityState = {
    ...crudInitialState
};

export const activityFeatureName = 'activity';

export const activityDefinition = createCrudDefinition<ActivityVO, ActivityListVO>(activityFeatureName , initialState);
/*
Ez egy minta sub definíció, ha a modulban 1-nél több CRUD-ra van szükség
export const activitySubDefinition = createCrudDefinition<ActivitySubVO, ActivitySubListVO>(activityDefinition, crudInitialState, 'activitySub');
 */

export function activityReducer<T, S>(state: ActivityState, action: All): ActivityState {
    switch (action.type) {
        default: {
            return CrudReducer(activityDefinition, state, action as CrudAll<T, S>) as ActivityState;
        }
    }
}
